import { defineStore } from 'pinia'
import { store } from '../index'

interface Legacy1_0State {
  legacyToken: string
}

// 1.0(家庭日+抢票)服务账号 token —— 家庭日/抢票 host 不同但共用同一套登录/token 校验, 只需一份 token。
// 字段名特意叫 legacyToken(而不是 token), 与主站 userStore.token / 2.0 的 bizStore.bizToken 区分, 三者不重名。
export const useLegacyStore = defineStore('legacy1_0', {
  state: (): Legacy1_0State => {
    return {
      legacyToken: ''
    }
  },
  getters: {
    getLegacyToken(): string {
      return this.legacyToken
    }
  },
  actions: {
    setLegacyToken(legacyToken: string) {
      this.legacyToken = legacyToken
    },
    reset() {
      this.legacyToken = ''
    }
  },
  persist: true
})

export const useLegacyStoreWithOut = () => {
  return useLegacyStore(store)
}
